//@ts-nocheck
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { fixedEncodeURIComponent, getRequest } from "../../../utils/jha-fetch";
import { Apis } from "../../../utils/api-constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../../utils/constants";
import Cookies from "js-cookie";
import Router from "@jack-henry/web-component-router";
import { routerConfig } from "../../../routers";
import { StatusConstants } from "../../../utils/apiStatusConstants";
import { openJhftDialog } from "../../../Components/JhftJhaDialog";
import { AppRouters } from "../../../utils/app-router";
import { getRoleData } from "../../../utils/getRoleData";
import {
  decryptValue,
  stringComparison,
} from "../../../utils/app-utils";
import "@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/icons/jha-icon-information";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import { getBusinessUnitName } from "../../../utils/getBusinessUnitName";
import { daysDiffernece } from "../../../utils/dateFormatter";
@customElement("user-info")
export class UserInfo extends formElementMixin(LitElement) {
  constructor() {
    super();
    // Explicitly set initial state
    this.hasUnsavedChanges = false;
    this.initialized = false;
  }

  @property({ type: Boolean }) private initialized = false;

  @property({ type: Boolean }) private readyToTrackChanges = false;

  @property({ type: Boolean }) hasUnsavedChanges = false;

  @property({ type: Boolean }) isChangingUserType = false;

  @property({ type: Boolean })
  isEditable = /readonly/i.test(decryptValue(Cookies.get("userRole")));

  @property()
  userId = "";

  @property({ type: Array })
  userTypes = [];
  @property({ type: Array })
  userRoles = [];
  @property({ type: Array })
  businessUnits = [];
  @property({ type: Boolean })
  isFolderLocationValid = false;
  @property({ type: Object })
  formData = {
    fullName: "",
    userId: "",
    email: "",
    businessUnit: "",
    homeDirectory: "",
    note: "",
    role: "",
    userType: "",
    eTag: "",
    userProfileType: "",
  };
  @property()
  userDetails = {};
  @property()
  loggedUserType = decryptValue(Cookies.get("userType"));

  // Store original form data to compare against
  private originalFormData: any = null;

  // Check if any field has actually changed from original
  private hasAnyFieldChanged(): boolean {
    if (!this.originalFormData) {
      return false;
    }

    const fieldsToCheck = [
      "fullName",
      "email",
      "businessUnit",
      "homeDirectory",
      "note",
      "role",
      "userType",
    ];

    for (const field of fieldsToCheck) {
      const currentValue = this.formData[field] || "";
      const originalValue = this.originalFormData[field] || "";

      if (currentValue !== originalValue) {
        return true;
      }
    }

    return false;
  }
  static get styles() {
    return [
      css`
        :host {
          overflow: visible;
        }
        #formDiv {
          display: flex;
          flex-direction: column;
          flex: 1;
          padding: 20px;
          overflow: visible;
        }
        #inputsDiv {
          display: grid;
          grid-template-columns: auto auto auto auto;
          column-gap: 48px;
          row-gap: 40px;
          overflow: visible;
        }
        form {
          display: flex;
          flex-direction: column;
          flex: 1;
          overflow: visible;
        }
        #actionBtns {
          display: flex;
          gap: 15px;
        }
        .expiredPassword {
          color: red;
          font-weight: bold;
          margin-bottom: 2%;
        }
      `,
    ];
  }

  firstUpdated(): void {
    this.initialized = true;
    // Wait for all form fields to finish initializing before tracking changes
    setTimeout(() => {
      this.hasUnsavedChanges = false;
      this.requestUpdate();

      // Wait a bit more before enabling change tracking to avoid catching re-render events
      setTimeout(() => {
        this.readyToTrackChanges = true;
      }, 200);
    }, 500);
  }

  updated(changedProperties: Map<string, any>): void {
    super.updated?.(changedProperties);

    // During initial load, ensure hasUnsavedChanges stays false
    if (!this.readyToTrackChanges && this.hasUnsavedChanges) {
      this.hasUnsavedChanges = false;
      // Don't call requestUpdate here to avoid infinite loop
    }
  }

  inputValueChange(e) {
    // Get the data-id attribute to identify which field changed
    const dataId = e.target?.getAttribute("data-id");
    const value = e.target?.value;

    // Update the formData object directly
    if (dataId && this.formData.hasOwnProperty(dataId)) {
      // Only update if value actually changed
      if (this.formData[dataId] !== value) {
        this.formData[dataId] = value;
      }
    }

    // Also call the mixin's updateProperty method for validation
    if (dataId) {
      this.updateProperty(dataId, value);
    }

    // Only track changes if we're ready
    if (this.readyToTrackChanges && this.originalFormData) {
      // Check if any field in the entire form has changed
      const hasChanges = this.hasAnyFieldChanged();

      if (this.hasUnsavedChanges !== hasChanges) {
        this.hasUnsavedChanges = hasChanges;
        // Trigger re-render to update button state
        this.requestUpdate();
      }
    }
  }

  async onSaveClick() {
    await this.dispatchEvent(
      new CustomEvent("onSaveInfoClick", {
        detail: this.formData,
        bubbles: true,
        composed: true,
      })
    );
    this.isEditable = false;
    this.hasUnsavedChanges = false;
  }

  @property()
  pageTitle = "Edit User";

  async connectedCallback() {
    super.connectedCallback();
    //window.addEventListener('beforeunload', this.beforeUnloadHandler());
    document.title = document.title.concat(" >", this.pageTitle);

    const userRoleRes = await getRequest(Apis.USER_ROLE);
    enum UserRoles {
      readonly = "Read Only",
      readwrite = "Read/Write",
    }
    const userRoles = getRoleData(userRoleRes?.list ?? []);
    this.userRoles = userRoles.map((userRole) => {
      userRole.name = UserRoles[userRole.value];
      return userRole;
    });

    const userTypesRes = await getRequest(Apis.USER_TYPE);
    enum UserTypes {
      participant = "Participant",
      businessadmin = "Business Admin",
      enterpriseadmin = "Enterprise Admin",
    }
    this.userTypes = getRoleData(userTypesRes?.list ?? []).map((userType) => {
      userType.name = UserTypes[userType.value];
      return userType;
    });
    const businessUnitsAllRes = await getRequest(
      Apis.GET_ALL_BUSINESSUNITVALUES
    );
    const businessUnitsRes = businessUnitsAllRes?.businessUnitValues ?? [];
    this.businessUnits = businessUnitsRes
      .filter(
        (bu) =>
          bu.status === "active" || bu.name === this.userDetails?.businessUnit
      )
      .map((y) => {
        return { value: y.value, name: y.name };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
    if (stringComparison(this.userDetails?.userType, "enterpriseadmin")) {
      const rec = {
        name: "All",
        value: "all",
      };
      this.businessUnits.push(rec);
    }
    this.formData = {
      fullName: this.userDetails?.fullName,
      userId: this.userDetails?.userId,
      email: this.userDetails?.email,
      businessUnit: this.userDetails?.businessUnit.toLowerCase(),
      homeDirectory: this.userDetails?.homeDirectory?.trim(),
      note: this.userDetails?.note,
      role: /readonly/i.test(this.userDetails?.role) ? "readonly" : "readwrite",
      userType: this.userDetails?.userType,
      eTag: this.userDetails?.eTag,
      userProfileType: this.userDetails?.userProfileType,
      authType: this.userDetails?.authType,
    };
    this.isFolderLocationValid = stringComparison(
      this.formData.userProfileType,
      "destination"
    )
      ? this.isValidFolderLocation(this.formData.homeDirectory)
      : false;
    if (stringComparison(this.loggedUserType, "BusinessAdmin")) {
      this.userTypes = this.userTypes.filter(
        (r) => !stringComparison(r.value, "enterpriseadmin")
      );
    }
    if (stringComparison(this.formData.userType, "participant")) {
      this.userTypes = this.userTypes.filter((r) =>
        stringComparison(r.value, "participant")
      );
    } else {
      this.userTypes = this.userTypes.filter(
        (r) => !stringComparison(r.value, "participant")
      );
    }
    this.formData.homeDirectory =
      this.formData.homeDirectory &&
        !this.formData.homeDirectory.startsWith("/")
        ? "/" + this.formData.homeDirectory
        : this.formData.homeDirectory;
    this.formData.homeDirectory =
      this.formData.homeDirectory && !this.formData.homeDirectory.endsWith("/")
        ? this.formData.homeDirectory + "/"
        : this.formData.homeDirectory;

    // Ensure hasUnsavedChanges is false after initial data load
    this.hasUnsavedChanges = false;

    // Store original form data for comparison
    this.originalFormData = { ...this.formData };
  }

  // private beforeUnloadHandler(event) { commented unused code effecting coverage
  //   if (this.hasUnsavedChanges) {
  //     event.preventDefault();
  //     event.returnValue = '';
  //   }
  // }

  async onCancelClick() {
    // isEditable is really "is read-only" here (see its initializer) — those users cannot
    // have changed anything. hasUnsavedChanges is the same signal that gates Save, so
    // Cancel and Save agree on what counts as a change: no change, no prompt.
    if (this.isEditable || !this.hasUnsavedChanges) {
      AppRouters.go("/users");
      return;
    }

    const result = await openJhftDialog({
      variant: "warning",
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to leave without saving?",
      cancelLabel: "Stay",
      confirmLabel: "Leave Without Saving",
    });

    if (result === "confirm") {
      AppRouters.go("/users");
    }
  }

  disconnectedCallback() {
    // window.removeEventListener('beforeunload', this.beforeUnloadHandler());
    this.dispatchEvent(
      new CustomEvent("onInfoTabChange", {
        detail: this.formData,
        bubbles: true,
        composed: true,
      })
    );
  }

  isValidFolderLocation(value: string): boolean {
    if (!value) {
      return false;
    }
    const regex = /^\/([a-zA-Z0-9#_\-]+\/)*[a-zA-Z0-9#_\-]+\/$/;
    const segmentRegex = /^[a-zA-Z0-9]+$/;
    if (!regex.test(value)) {
      return false;
    }
    return value.split("/").every((segment) => {
      if (segment === "") {
        return true;
      }
      return (
        segmentRegex.test(segment[0]) && segmentRegex.test(segment.slice(-1))
      );
    });
  }

  onFolderLocationChange(e) {
    if (e.target.value) {
      const regex = /^\/([a-zA-Z0-9#_\-]+\/)*[a-zA-Z0-9#_\-]+\/$/;
      let strRegex = /^[a-zA-Z0-9]+$/;
      let inValid: boolean = false;
      if (!regex.test(e.target.value)) {
        inValid = true;
      } else {
        var innerValues = e.target.value?.split("/");
        innerValues.forEach((element) => {
          if (
            element !== "" &&
            (!strRegex.test(element[0]) || !strRegex.test(element.slice(-1)))
          ) {
            inValid = true;
          }
        });
      }
      const invalidField = this.shadowRoot.querySelector(
        "jha-form-text-input[data-auto-id='homeDirectoryInput']"
      );
      if (invalidField) {
        if (
          !stringComparison(this.formData.userType, "enterpriseadmin") &&
          inValid
        ) {
          invalidField.warning = "Please enter a valid input.";
          invalidField.showWarning = true;
          this.isFolderLocationValid = false;
          this.updateProperty("homeDirectory", e.target.value);
        } else {
          invalidField.showWarning = false;
          this.isFolderLocationValid = true;
          this.updateProperty("homeDirectory", e.target.value);
        }
      }
    }

    // Only track changes if we're ready
    if (this.readyToTrackChanges && this.originalFormData) {
      // Check if any field in the entire form has changed
      const hasChanges = this.hasAnyFieldChanged();

      if (this.hasUnsavedChanges !== hasChanges) {
        this.hasUnsavedChanges = hasChanges;
        this.requestUpdate();
      }
    }
  }
  async onUserTypeChange(e) {
    const newUserType = e.target.value;

    this.isChangingUserType = true;
    this.updateProperty("userType", newUserType);

    if (stringComparison(newUserType, "enterpriseadmin")) {
      if (this.businessUnits.find((r) => r.value === "all")) {
      } else {
        const rec = {
          name: "All",
          value: "all",
        };
        this.businessUnits.push(rec);
      }
      this.updateProperty("businessUnit", "all");
      this.formData.businessUnit = "all";

      const homeDirectoryInput = this.shadowRoot.querySelector(
        "jha-form-text-input[data-auto-id='homeDirectoryInput']"
      );
      if (homeDirectoryInput) {
        homeDirectoryInput.value = "";
      }
      this.updateProperty("homeDirectory", "");
      this.isFolderLocationValid = true;
    } else {
      if (!stringComparison(this.loggedUserType, "BusinessAdmin")) {
        this.businessUnits = this.businessUnits.filter(
          (r) => r.value !== "all"
        );
        // Restore the original business unit and home directory values
        const originalBusinessUnit = this.originalFormData?.businessUnit || "";
        this.updateProperty("businessUnit", originalBusinessUnit);
        this.formData.businessUnit = originalBusinessUnit;

        // Also restore home directory for regular users (not business admin)
        if (
          stringComparison(this.formData.userProfileType, "regular") &&
          !stringComparison(newUserType, "businessadmin")
        ) {
          const originalHomeDirectory =
            this.originalFormData?.homeDirectory || "";
          this.updateProperty("homeDirectory", originalHomeDirectory);
          this.formData.homeDirectory = originalHomeDirectory;

          // Update the input field
          const homeDirectoryInput = this.shadowRoot.querySelector(
            "jha-form-text-input[data-auto-id='homeDirectoryInput']"
          );
          if (homeDirectoryInput) {
            homeDirectoryInput.value = originalHomeDirectory;
          }

          // Re-validate the folder location
          if (originalHomeDirectory) {
            const regex = /^\/([a-zA-Z0-9#_\-]+\/)*[a-zA-Z0-9#_\-]+\/$/;
            this.isFolderLocationValid = regex.test(originalHomeDirectory);
          } else {
            this.isFolderLocationValid = false;
          }
        } else if (stringComparison(newUserType, "businessadmin")) {
          // For business admin, folder location is not required
          this.isFolderLocationValid = true;
        } else {
          // For participant users
          this.isFolderLocationValid = false;
        }
      }
    }

    // Only track changes if we're ready
    if (this.readyToTrackChanges && this.originalFormData) {
      // Check if any field in the entire form has changed
      const hasChanges = this.hasAnyFieldChanged();

      if (this.hasUnsavedChanges !== hasChanges) {
        this.hasUnsavedChanges = hasChanges;
      }
    }

    // First render to update the form fields
    this.requestUpdate();

    // Wait for the update to complete, then update field values and re-render
    await this.updateComplete;

    setTimeout(() => {
      const businessUnitSelect = this.shadowRoot.querySelector(
        "jha-form-select[data-auto-id='businessUnitSelect']"
      );
      if (businessUnitSelect) {
        if (stringComparison(newUserType, "enterpriseadmin")) {
          businessUnitSelect.value = "all";
        } else if (!stringComparison(this.loggedUserType, "BusinessAdmin")) {
          // Restore the original business unit value when switching away from Enterprise Admin
          const originalBusinessUnit =
            this.originalFormData?.businessUnit || "";
          businessUnitSelect.value = originalBusinessUnit;
        }
      }
      // Reset the flag after transition is complete
      this.isChangingUserType = false;
      // Force another update to ensure the form validation state is current
      this.requestUpdate();
    }, 150);
  }

  render() {
    return html`
      <div id="formDiv">
        <form>
          <div id="inputsDiv">
            ${stringComparison(this.formData.userProfileType, "destination")
        ? html`
                  <jha-tooltip
                    bottom
                    text="Folder path within the destination bucket. The folder is created under {BusinessUnitId}/FolderName if it does not already exist. Format: /FolderName/. Max length of 256 characters."
                  >
                    <jha-form-text-input
                      label="Folder Location"
                      required
                      warning="Please Provide Valid Folder Location"
                      type="text"
                      .value=${this.formData.homeDirectory}
                      outline
                      data-id="homeDirectory"
                      data-auto-id="homeDirectoryInput"
                      placeholder="Eg: /FolderName/"
                      ?disabled=${this.isEditable}
                      @change=${this.onFolderLocationChange}
                      maxlength="256"
                    >
                    </jha-form-text-input>
                  </jha-tooltip>
                `
        : html`
                  <jha-tooltip
                    bottom
                    text="User Type determines the access levels for the user."
                  >
                    <jha-form-select
                      outline
                      label="User Type"
                      .options=${this.userTypes}
                      lableKey="name"
                      valueKey="value"
                      data-id="userType"
                      data-auto-id="userTypeSelect"
                      .value=${this.formData.userType}
                      ?disabled=${this.isEditable}
                      @change=${this.onUserTypeChange}
                      required
                      warning="Please Select An User Type."
                    ></jha-form-select>
                  </jha-tooltip>
                `}
            <jha-tooltip
              bottom
              text="User Role determines the permissions for the user."
            >
              <jha-form-select
                outline
                label="User Role"
                .options=${this.userRoles}
                lableKey="name"
                valueKey="value"
                data-id="role"
                data-auto-id="roleSelect"
                .value=${this.formData.role}
                ?disabled=${this.isEditable}
                @change=${this.inputValueChange}
                required
                warning="Please Select An User Role."
              ></jha-form-select>
            </jha-tooltip>
            <jha-tooltip
              bottom
              text="Full Name of the user. Max length of 60 characters."
            >
              <jha-form-input
                label="Full Name"
                required
                ?disabled=${this.isEditable}
                warning="Full Name Required."
                type="text"
                .value=${this.formData.fullName}
                data-id="fullName"
                data-auto-id="fullNameInput"
                @change=${this.inputValueChange}
                maxlength="60"
                charlimit="60"
                outline
              >
              </jha-form-input>
            </jha-tooltip>
            <jha-tooltip
              bottom
              text="User ID is the unique identifier for the user. Max length of 60 characters."
            >
              <jha-form-input
                label="User ID"
                required
                disabled
                warning="User ID Required."
                .value=${this.formData.userId}
                data-id="userId"
                data-auto-id="userIdInput"
                @change=${this.inputValueChange}
                maxlength="60"
                charlimit="60"
                type="text"
                outline
              >
              </jha-form-input>
            </jha-tooltip>
            <jha-tooltip
              bottom
              text="Email address of the user. Max length of 256 characters."
            >
              <jha-form-input
                label="Email"
                required
                ?disabled=${this.isEditable}
                warning="Email Required."
                type="email"
                placeholder="Email Address"
                label="Email Address"
                .value=${this.formData.email}
                outline
                data-id="email"
                data-auto-id="emailInput"
                @change=${this.inputValueChange}
                maxlength="256"
              >
              </jha-form-input>
            </jha-tooltip>
            <jha-tooltip
              bottom
              text="Business Unit determines the access levels for the user."
            >
              <jha-form-select
                outline
                label="Business Unit"
                .options=${this.businessUnits}
                lableKey="name"
                valueKey="value"
                data-id="businessUnit"
                data-auto-id="businessUnitSelect"
                ?disabled=${this.isEditable ||
      stringComparison(this.loggedUserType, "BusinessAdmin") ||
      (stringComparison(this.formData.userProfileType, "regular") &&
        stringComparison(this.formData.userType, "enterpriseadmin"))}
                @change=${this.inputValueChange}
                .value=${this.formData.businessUnit}
                required
                warning="Please Provide Business Unit."
                emptyOptionLabel="Select Business Unit"
              ></jha-form-select>
            </jha-tooltip>
            ${stringComparison(this.formData.userProfileType, "regular") &&
        !stringComparison(this.formData.userType, "businessadmin") &&
        !stringComparison(this.formData.userType, "enterpriseadmin")
        ? html`
                  <jha-tooltip
                    bottom
                    text="/Folder/path/ where the user will be able to access files. Max length of 256 characters."
                  >
                    <jha-form-text-input
                      label="Folder"
                      .required=${!stringComparison(
          this.formData.userType,
          "enterpriseadmin"
        )}
                      ?disabled=${this.isEditable ||
          stringComparison(
            this.formData.userType,
            "enterpriseadmin"
          )}
                      warning="Please Provide Valid Folder Location"
                      type="text"
                      .value=${this.formData.homeDirectory}
                      outline
                      data-id="homeDirectory"
                      data-auto-id="homeDirectoryInput"
                      @change=${this.onFolderLocationChange}
                      maxlength="256"
                    >
                    </jha-form-text-input>
                  </jha-tooltip>
                `
        : undefined}
            <jha-tooltip
              bottom
              text="Notes for the user. Max length of 256 characters."
            >
              <jha-form-textarea-input
                id="notesTextArea"
                role="textbox"
                minlength="0"
                maxlength="256"
                type="text"
                rows="5"
                ?disabled=${this.isEditable}
                .value=${this.formData.note}
                data-id="note"
                data-auto-id="noteInput"
                label="Notes"
                @change=${this.inputValueChange}
              >
              </jha-form-textarea-input>
            </jha-tooltip>
          </div>
          <div style="flex:1;"></div>
          ${daysDiffernece(
          new Date(),
          new Date(this.userDetails.passwordExpiryDateTime)
        ) <= 0
        ? html`<div class="expiredPassword">
                ${this.userDetails?.authType === "ssh"
            ? "SSH Public Key is expired. Please use User Authentication page to reset the SSH Public Key."
            : "Password is expired. Please use User Authentication page to reset the password."}
              </div>`
        : undefined}
          <div id="actionBtns">
            ${!this.isEditable
        ? html` <jha-tooltip
                  top-right
                  text="Click to save user information."
                >
                  <jha-button
                    data-auto-id="saveBtn"
                    type="submit"
                    ?disabled=${(() => {
            const shouldDisable =
              !this.hasUnsavedChanges ||
              (!this.isChangingUserType &&
                (!this.formValid ||
                  (stringComparison(
                    this.formData.userProfileType,
                    "regular"
                  ) &&
                    !stringComparison(
                      this.formData.userType,
                      "enterpriseadmin"
                    ) &&
                    !stringComparison(
                      this.formData.userType,
                      "businessadmin"
                    ) &&
                    !this.isFolderLocationValid) ||
                  (stringComparison(
                    this.formData.userProfileType,
                    "destination"
                  ) &&
                    !this.isFolderLocationValid)));
            return shouldDisable;
          })()}
                    sync
                    @click=${this.onSaveClick}
                    >Save User</jha-button
                  >
                </jha-tooltip>`
        : undefined}
            <jha-tooltip
              top-right
              text="Click to cancel and exit without saving."
            >
              <jha-button
                data-auto-id="cancelBtn"
                tertiary
                sync
                @click=${this.onCancelClick}
                >Cancel</jha-button
              >
            </jha-tooltip>
          </div>
        </form>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "user-info": UserInfo;
  }
}
